import { type FC } from 'react';

import { Badge } from '@repo/ui/components/common';

import { useCartCount } from '@/client/hooks/cart.hooks';

/**
 * Suspends until the root route's cart promise resolves — render inside a
 * `<Suspense>`.
 */
export const CartCountBadge: FC = () => {
  const count = useCartCount();

  if (count <= 0) {
    return null;
  }

  return (
    <Badge className="bg-primary text-primary-foreground absolute -top-1 -right-1 h-5 min-w-5 rounded-full px-1 text-xs font-bold">
      {count}
    </Badge>
  );
};
